import request from '@/utils/request'

//获得红包详情
export function takeRedpackDetail(params) {
  return request({
    url: '/product/red-packet/qrcode/details',
    method: 'get',
    params,
  })
}

//领取红包
export function takeRedpack(params) {
  return request({
    url: '/product/red-packet/take',
    method: 'get',
    params,
  })
}
